import React from 'react';
import { Button } from 'antd';

const CustomButton = ({
  type = 'primary',
  onClick,
  icon,
  size = 'XL',
  loading,
  children,
  shape = 'round',
  disabled = false,
  variant,
  style = {},
  color = 'primary',
  ...rest
}) => {
  const styling = {
    ...style,
    ...(size == 'XL' ? { padding: '24px' } : {}),
  };

  return (
    <Button
      color={color}
      variant={variant}
      type={type}
      shape={shape}
      onClick={onClick}
      icon={icon}
      loading={loading}
      size={size == 'XL' ? 'large' : size ? size : 'default'}
      disabled={disabled}
      style={{ ...styling }}
      {...rest}
    >
      {children}
    </Button>
  );
};

export default CustomButton;
